import gql from 'graphql-tag';

const updateRulesMutation = gql`
  mutation UpdateRules($input: UpdateRulesInput!) {
    updateRules(input: $input) {
      success
      errors
    }
  }
`;

export default updateRulesMutation;
